module.exports = __webpack_public_path__ + "img/grade4.b8b468c7.jpg";